const pageNameKey = "otaModal";

export const otaModalEn = {
  [pageNameKey]: {
    firmwareVersionDetailsText: "Firmware Details",
    configurationDetailsText: "Configuration Details",
    firmwareDetailsText: "Firmware Details",
    rollbackButtonText: "Rollback",
    downloadButtonText: "Download",
    deleteButtonText: "Delete",
    failedMsg: "Failed to start installation",
    errorMsg: "Something went wrong while starting installation.",
    deleteSuccess: "Package deleted successfully.",
    deleteFailed: "Package cannot be deleted.",
    errorDelete: "Something went wrong while deleting package.",
    pushFirmwareText: "Push Firmware",
    pushBackupText: "Push Backup",
  },
};

export const otaModalPtBr = {
  [pageNameKey]: {
    firmwareVersionDetailsText: "Detalhes do firmware",
    configurationDetailsText: "Detalhes da configuração",
    firmwareDetailsText: "Detalhes do firmware",
    rollbackButtonText: "Rollback",
    downloadButtonText: "Baixar",
    deleteButtonText: "Excluir",
    failedMsg: "Falha ao iniciar instalação",
    errorMsg: "Algo deu errado ao iniciar a instalação.",
    deleteSuccess: "Pacote excluído com sucesso.",
    deleteFailed: "Não é possível excluir o pacote.",
    errorDelete: "Algo deu errado ao excluir o pacote.",
    pushFirmwareText: "Enviar Firmware",
    pushBackupText: "Enviar Backup",
  },
};

export const otaModalEs = {
  [pageNameKey]: {
    firmwareVersionDetailsText: "Detalles del firmware",
    configurationDetailsText: "Detalles de la configuración",
    firmwareDetailsText: "Detalles del firmware",
    rollbackButtonText: "Rollback",
    downloadButtonText: "Descargar",
    deleteButtonText: "Eliminar",
    failedMsg: "No se pudo iniciar la instalación",
    errorMsg: "Algo salió mal al iniciar la instalación.",
    deleteSuccess: "Paquete eliminado correctamente.",
    deleteFailed: "No se puede eliminar el paquete.",
    errorDelete: "Algo salió mal al eliminar el paquete.",
    pushFirmwareText: "Enviar Firmware",
    pushBackupText: "Enviar Copia de Seguridad",
  },
};

export const otaModalDe = {
  [pageNameKey]: {
    firmwareVersionDetailsText: "Firmware-Details",
    configurationDetailsText: "Konfigurationsdetails",
    firmwareDetailsText: "Firmware-Details",
    rollbackButtonText: "Zurücksetzen",
    downloadButtonText: "Herunterladen",
    deleteButtonText: "Löschen",
    failedMsg: "Installation konnte nicht gestartet werden",
    errorMsg: "Beim Starten der Installation ist ein Fehler aufgetreten.",
    deleteSuccess: "Paket erfolgreich gelöscht.",
    deleteFailed: "Paket kann nicht gelöscht werden.",
    errorDelete: "Beim Löschen des Pakets ist ein Fehler aufgetreten.",
    pushFirmwareText: "Firmware übertragen",
    pushBackupText: "Backup übertragen",
  },
};

export const otaModalZhHans = {
  [pageNameKey]: {
    firmwareVersionDetailsText: "固件详细信息",
    configurationDetailsText: "配置详情",
    firmwareDetailsText: "固件详情",
    rollbackButtonText: "回滚",
    downloadButtonText: "下载",
    deleteButtonText: "删除",
    failedMsg: "启动安装失败",
    errorMsg: "启动安装时发生错误。",
    deleteSuccess: "软件包删除成功。",
    deleteFailed: "Paket kann nicht gelöscht werden.",
    errorDelete: "删除软件包时发生错误。",
    pushFirmwareText: "推送固件",
    pushBackupText: "推送备份",
  },
};

export const otaModalIt = {
  [pageNameKey]: {
    firmwareVersionDetailsText: "Dettagli firmware",
    configurationDetailsText: "Dettagli configurazione",
    firmwareDetailsText: "Dettagli firmware",
    rollbackButtonText: "Ripristina",
    downloadButtonText: "Scarica",
    deleteButtonText: "Elimina",
    failedMsg: "Impossibile avviare l'installazione",
    errorMsg: "Si è verificato un errore durante l'avvio dell'installazione.",
    deleteSuccess: "Pacchetto eliminato con successo.",
    deleteFailed: "Impossibile eliminare il pacchetto.",
    errorDelete:
      "Si è verificato un errore durante l'eliminazione del pacchetto.",
    pushFirmwareText: "Invia Firmware",
    pushBackupText: "Invia Backup",
  },
};

export const otaModalNl = {
  [pageNameKey]: {
    configurationDetailsText: "Configuratiedetails",
    deleteButtonText: "Verwijderen",
    deleteFailed: "Pakket kan niet worden verwijderd.",
    deleteSuccess: "Pakket succesvol verwijderd.",
    downloadButtonText: "Downloaden",
    errorDelete:
      "Er is een fout opgetreden bij het verwijderen van het pakket.",
    errorMsg: "Er is een fout opgetreden bij het starten van de installatie.",
    failedMsg: "Installatie kon niet worden gestart",
    firmwareDetailsText: "Firmwaredetails",
    firmwareVersionDetailsText: "Firmwaredetails",
    rollbackButtonText: "Resetten",
    pushFirmwareText: "Firmware verzenden",
    pushBackupText: "Backup verzenden",
  },
};

export const otaModalTr = {
  [pageNameKey]: {
    firmwareVersionDetailsText: "Aygıt Yazılımı Ayrıntıları",
    configurationDetailsText: "Yapılandırma Ayrıntıları",
    firmwareDetailsText: "Aygıt Yazılımı Ayrıntıları",
    rollbackButtonText: "Geri alma",
    downloadButtonText: "İndirmek",
    deleteButtonText: "Silmek",
    failedMsg: "Kurulum başlatılamadı",
    errorMsg: "Kurulum başlatılırken bir şeyler ters gitti.",
    deleteSuccess: "Paket başarıyla silindi.",
    deleteFailed: "Paket silinemez.",
    errorDelete: "Paket silinirken bir şeyler ters gitti.",
    pushFirmwareText: "Firmware'i itin",
    pushBackupText: "Yedeklemeyi itin",
  },
};
